export const getPpiConfigurations = (state) => {
  return state.VNPPI.get('configurations')
}

export const getPpiOrderDetails = (state, orderUuid) => {
  return state.VNPPI.getIn(['orders', orderUuid])
}